/**
 * Created by quikr on 12/9/16.
 */
import {beginAjaxCall} from "../ajaxStatusActions";
import _ApiCli from "../../../helpers/ApiCli";

let AjaxCall = new _ApiCli();


export function getActiveEmployeeSuccess(employees) {
  return {type: 'GET_ACTIVE_EMPLOYEES_SUCCESS', employees}
}

export function getActiveEmployee() {

  return function (dispatch, getState) {
    dispatch(beginAjaxCall());
    let call1 = AjaxCall.asyncAction('/activeEmp', 'get', null, null, dispatch);
    call1.then((response) => {

      const employees = response.data.data;
      dispatch(getActiveEmployeeSuccess(employees));
    }).catch((error) => {
    });

  }
}



/** WEBPACK FOOTER **
 ** ./src/redux/actions/Employee/employeeActions.js
 **/